import Immutable from "immutable";
import * as types from "./constants";

const initialState = Immutable.fromJS({
  isSignedIn: false
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOG_IN_USER:
      return state.mergeDeep({
        user: Immutable.fromJS(action.payload),
        isSignedIn: true
      });
    case types.LOG_OUT_USER:
      return initialState;
    default:
      return state;
  }
};

export default authReducer;
